import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import { models, RootModel } from '../models';

// Extend RematchDispatch to include optional meta
type DispatchWithMeta<T extends RootModel> = {
  [K in keyof T]: {
    [Action in keyof T[K]['reducers']]: T[K]['reducers'][Action] extends (
      state: any,
      payload: infer P
    ) => any
      ? (payload: P, meta?: { source?: string }) => void
      : never;
  };
};

export const store = init({
  models,
});

export const dispatch = store.dispatch as RematchDispatch<RootModel> &
  DispatchWithMeta<RootModel>;
export type Store = typeof store;
export type Dispatch = typeof dispatch;
export type RootState = RematchRootState<RootModel>;
